import { Box, Typography } from '@capitalise/ui-design-system';
import Spacer from 'components/Spacer';
import UserAvatar from 'assets/svgs/user-avatar.svg';
import { directorTips } from '../Director/DirectorInfoPanel';

const ContentDirectorConsent = () => (
  <Spacer noRight flexDirection="column">
    <Box display="flex" flexDirection="column" alignItems="center" mt="small">
      <UserAvatar />
      <Typography mt="small" mb="xsmall" size="heading-32" color="grey-900">
        Unfortunately we couldn’t verify your details
      </Typography>
    </Box>
    <Typography size="heading-22" color="grey-900" mb="xsmall">
      Tips for filling out the form
    </Typography>
    {directorTips.map((tip, index) => (
      <Box display="list-item" ml="3xsmall" key={`tip_${index}`} mb="xsmall">
        <Typography size="heading-18" color="grey-700">
          {tip.title}
        </Typography>
        <Typography size="body-16">{tip.description}</Typography>
      </Box>
    ))}
  </Spacer>
);

export default ContentDirectorConsent;
